import { useEffect } from 'react';

export const SITE_URL = 'https://grceducators.com';
export const DEFAULT_OG_IMAGE =
  'https://static.prod-images.emergentagent.com/jobs/2f1d2485-1030-4ea3-978b-d78b215747ec/images/8ec770c34fa3ba79ac5628aa6c912d4f4524b6cac985d36660183b13aefc80cb.jpeg';
export const ORG_LOGO =
  'https://static.prod-images.emergentagent.com/jobs/2f1d2485-1030-4ea3-978b-d78b215747ec/images/53a1af8b9b7f547ab99c00fd93074b8edafd57d26727ced17ea4d18f34d0b218.jpeg';

const DEFAULT_TITLE =
  'GRC Educators | Governance, Risk & Compliance Webinars & Certifications';
const DEFAULT_DESCRIPTION =
  'GRC Educators delivers expert-led webinars and certifications in governance, risk, and compliance across healthcare, banking, HR, finance and more — live and on-demand training for professionals.';

const setMeta = (attr, key, content) => {
  if (content === undefined || content === null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  path,
  image,
  type = 'website',
  jsonLd,
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | GRC Educators` : DEFAULT_TITLE;

  useEffect(() => {
    const cleanPath =
      path !== undefined ? path : window.location.pathname;
    const url = `${SITE_URL}${cleanPath}`;
    const img = image || DEFAULT_OG_IMAGE;

    document.title = fullTitle;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    setLink('canonical', url);

    setMeta('property', 'og:type', type);
    setMeta('property', 'og:site_name', 'GRC Educators');
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', img);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', img);

    // Per-page JSON-LD (kept separate from the sitewide Organization/WebSite blocks)
    const existing = document.getElementById('seo-page-jsonld');
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'seo-page-jsonld';
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [fullTitle, description, path, image, type, noindex, jsonLd]);

  return null;
};

export default SEO;
